import { render, staticRenderFns } from "./ProfileExperienceCard.vue?vue&type=template&id=2b5c5df7"
import script from "./ProfileExperienceCard.vue?vue&type=script&lang=ts"
export * from "./ProfileExperienceCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b5c5df7')) {
      api.createRecord('2b5c5df7', component.options)
    } else {
      api.reload('2b5c5df7', component.options)
    }
    module.hot.accept("./ProfileExperienceCard.vue?vue&type=template&id=2b5c5df7", function () {
      api.rerender('2b5c5df7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/experiences/ProfileExperienceCard.vue"
export default component.exports